import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { RouteName } from '@mews-commander/enums';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Counter/Index/')({
    validateSearch: z.object({
        OwnerId: z.string().uuid().optional(),
        tab: z.string().optional(),
    }),
    loader: ({ params: { currentEnterpriseId } }) => {
        throw redirect({
            to: '/$currentEnterpriseId/Settings/Counters/Bill',
            params: { currentEnterpriseId },
        });
    },
    staticData: {
        routeName: RouteName.CounterIndex,
        owner: MewsTeam.Billing,
        type: RouteType.Redirect,
    },
});
